import React, { useState, useEffect, useMemo } from 'react';
import { getAllVehicleJob, getAllJob, getAllCustomerJob } from '../../../../Core/Services/InternalUser/JOB/jobService';
import DataGrid from '../../../../Core/Controls/Grid';
import DialogComp from '../../../../Core/Dialog/DialogComp';
import { EditButton, BreadCrumbs, formatters } from '../../../../Core/Controls';
import JobScreenModal from './JobScreenModal';
import { Link } from 'react-router-dom';
import WorkIcon from '@material-ui/icons/Work';
import { CustomIconButton } from '../../../../Core/Controls/Inputs/Buttons/ButtonModal';
import { useLoginInfo } from '../../../../Core/Hooks/useLoginInfo';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';
import Grid from '@material-ui/core/Grid';
import { useHistory } from 'react-router-dom';
import JobQueryModal from './JobStatusBtn/JobQuery';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import ReactDOM from 'react-dom';
import DepotDetails from '../DetailsModal/depotDetails';
import CustomerDetails from '../DetailsModal/customerDetails';
import ServiceAgentDetails from '../DetailsModal/serviceAgent';
import { AppStorage } from '../../../../Core/Basic/storage-service';
const base_columns = [
    { key: 'action', name: 'Action', width: 120, addFileUploaderIcon: true },
    { key: 'jobDate', name: 'Date', formatter: formatters.Date_DDMMYYYY, width: 100 },
    { key: 'agentOrderNo', name: 'Job Ref', width: 150 },
    { key: 'vehicleJobStatus', name: 'Job Status', width: 110 },
    { key: 'jobDescription', name: 'Job Description' },
    { key: 'serviceAgentName', name: 'Service Agent', width: 200 },
    { key: 'depotName', name: 'Depots', width: 100 },
    {
        key: 'partsTotal',
        name: 'Parts',
        formatter: formatters.NumberWithPound,
        align: 'right',
        width: 110
    },
    {
        key: 'labourTotal',
        name: 'Labour',
        formatter: formatters.NumberWithPound,
        align: 'right',
        width: 110
    },
    {
        key: 'orderTotal',
        name: 'Total',
        formatter: formatters.NumberWithPound,
        align: 'right',
        width: 80
    }
];

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Jobs', active: true },
    { name: 'All Jobs', active: true }
];

function JobScreen(props) {
    let checkhaveAccess = AppStorage.getAllowAcces();
    const history = useHistory();
    let getUrl = `VehicleJob/${props.VehicleID ? `?VehicleID=${props.VehicleID}` : ''}${props.customerID ? `?customerID=${props.customerID}` : ''}`;
    const [state, setState] = useState({
        jobList: [],
        loader: true,
        open: false
    });
    const isCustomer = useLoginInfo().userRoles.includes('customer');
    useEffect(async () => {
        pullJobList();
    }, [props.VehicleID]);

    const pullJobList = async () => {
        setState((st) => ({
            ...st,
            isReload: new Date()
        }));
    };

    const jobHandler = (params) => {
        setState((state) => ({ ...state, open: true }));
    };

    const handleEditClick = (val) => {
        history.push({
            pathname: `/controller/jobTabScreen/${val?.jobID}/${props.VehicleID ? props.VehicleID : val?.vehicleID}`,
            search: '',
            state: { position: 'jobs', vorVehicleID: val.vorVehicleID }
        });
    };

    const handleShowQueries = (val) => {
        setState((state) => ({ ...state, showJobQuery: true, jobID: val?.jobID }));
    };

    const closeTheDialog = (val) => {
        setState((state) => ({ ...state, showJobQuery: false, jobID: '' }));
    };

    const ActionButtons = (data, row) => {
        return (
            <div style={{ textAlign: 'center' }}>
                <CustomIconButton
                    icon={SpeakerNotesIcon}
                    className="modal-btn-update btn_space"
                    toolTipTitle="Show Queries"
                    onClick={() => handleShowQueries(row)}
                />
                {checkhaveAccess?.CanViewJobs && (
                    <CustomIconButton icon={WorkIcon} className="modal-btn-update btn_space" toolTipTitle="Edit Job" onClick={() => handleEditClick(row)} />
                )}
            </div>
        );
    };

    const handelRowCick = (row, name) => {
        setState((st) => ({
            ...st,
            selectedRowData: row,
            [name]: true
        }));
    };

    const renderRegNumberEdit = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div onClick={() => handleEditRegClick(row)} style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }}>
                {row.vehicleRegNumber}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const renderAgentName = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div onClick={() => handelRowCick(row, 'showSaModal')} style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }}>
                {row.serviceAgentName}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const renderDepotName = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div onClick={() => handelRowCick(row, 'showDepotModal')} style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }}>
                {row.depotName}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const renderCustomerName = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div onClick={() => handelRowCick(row, 'showCustomerModal')} style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }}>
                {row.customerCompanyName}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const handleEditRegClick = (val) => {
        history.push({
            pathname: `/controller/editVehicle/${val.vehicleID}`,
            search: '',
            state: { fileCount: val.fileCount }
        });
    };

    const handleClose = () => {
        setState((st) => ({
            ...st,
            open: false,
            showSaModal: false,
            showCustomerModal: false,
            showDepotModal: false
        }));
    };

    const columns = useMemo(() => {
        let newColumn = [...base_columns];
        let actionCol = newColumn.find((item) => item.key === 'action');
        let agentNameCol = newColumn.find((element) => element.key === 'serviceAgentName');
        let depotNameCol = newColumn.find((element) => element.key === 'depotName');
        if (actionCol) {
            actionCol.formatter = ActionButtons;
        }
        if (depotNameCol) {
            depotNameCol.formatter = renderDepotName;
        }
        if (agentNameCol) {
            agentNameCol.formatter = renderAgentName;
        }
        if (!props.VehicleID) {
            newColumn.splice(3, 0, { key: 'vehicleRegNumber', name: 'Reg Number', width: 110, formatter: renderRegNumberEdit });
        }
        if (!props.customerID && !isCustomer && !props.VehicleID) {
            newColumn.splice(5, 0, { key: 'customerCompanyName', name: 'Customer', formatter: renderCustomerName, width: 150 });
        }
        return newColumn;
    }, []);

    const closeModal = (res) => {
        setState((state) => ({ ...state, open: false }));
        res && pullJobList();
    };
    const gridBtnTitle = !props.VehicleID ? '' : isCustomer ? '' : 'Add Job';
    const page = props.VehicleID ? true : props.customerID ? true : false;
    return (
        <div className={`${!page && 'screen'}` + ' controller-screen'} style={{ marginTop: 8 }}>
            {state.open && (
                <DialogComp open={state.open} onClose={() => closeModal(false)} title="Add Job" maxWidth="md">
                    <JobScreenModal VehicleID={props.VehicleID} onClose={() => closeModal(true)} />
                </DialogComp>
            )}
            {!page && <BreadCrumbs crumbs={crumbs} />}
            {state.showJobQuery && (
                <DialogComp title="Job Queries" maxWidth="sm" onClose={() => closeTheDialog(false)}>
                    <JobQueryModal title="" jobQueryJobID={state.jobID} onClose={closeTheDialog} />
                </DialogComp>
            )}
            <GijgoGrid
                columns={columns}
                btnTitle={gridBtnTitle}
                onBtnClick={jobHandler}
                idFieldName={`${checkhaveAccess?.CanUploadJobDocuments ? 'jobID' : null}`}
                fileUploaderConfigName={`${checkhaveAccess?.CanUploadJobDocuments ? 'JobScreen' : null}`}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                isReload={state.isReload}
                getUrl={getUrl}
            />
            {state.showSaModal ? (
                <DialogComp open={true} onClose={handleClose} title={'Service Agent Details'}>
                    <ServiceAgentDetails serviceAgentID={state.selectedRowData.jobServiceAgentID} onFormSubmit={handleClose} />
                </DialogComp>
            ) : null}
            {state.showCustomerModal ? (
                <DialogComp open={true} onClose={handleClose} title={'Customer Details'}>
                    <CustomerDetails customerID={state.selectedRowData.customerID} onFormSubmit={handleClose} />
                </DialogComp>
            ) : null}
            {state.showDepotModal ? (
                <DialogComp open={true} onClose={handleClose} title={'Depot Details'}>
                    <DepotDetails customerID={state.selectedRowData.jobDepotID} onFormSubmit={handleClose} />
                </DialogComp>
            ) : null}
        </div>
    );
}
export default JobScreen;
